import './Landingpage.scss';

import profil1 from 'assets/images/landingpage/profil_1.png';
import profil2 from 'assets/images/landingpage/profil_2.png';
import profil3 from 'assets/images/landingpage/profil_3.png';
import profil4 from 'assets/images/landingpage/profil_4.png';
import profil5 from 'assets/images/landingpage/profil_5.png';
import profil6 from 'assets/images/landingpage/profil_6.png';
import logoWithWriting from 'assets/images/logos/logo-with-writing.svg';

import AndroidIcon from '@mui/icons-material/Android';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';
import { Button, ThemeProvider, createTheme } from '@mui/material';
import { deDE } from '@mui/material/locale';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';

import ForgotPasswordModal from 'components/ForgotPasswordModal';
import ForgotPasswordModalx from 'components/ForgotPasswordModalx';
import LoginModal from 'components/NewRegister/Login';
import Config from 'config';
import { FORGOT_PASSWORD_PATH, FORGOT_PASSWORD_PATHH, REGISTER_USER } from 'models/Paths';
import AppleLoginButton from 'services/Apple/AppleLoginButton';
import useAppleLoginHandler from 'services/Apple/useAppleLoginHandler';
import FBLoginButton from 'services/Facebook/FBLoginButton';
import useLoginHandler from 'services/Facebook/useLoginHandler';
import GoogleLoginButton from 'services/Google/GoogleLoginButton';
import useGoogleLoginHandler from 'services/Google/useGoogleLoginHandler';

import { DefaultTheme } from '../../theme/DefaultTheme';
import AppbarComponent from './components/AppbarComponent';

export interface ILandingpageProps {}

export const Landingpage = React.memo((_props: ILandingpageProps) => {
    const history = useHistory();
    const [isLoading, setLoading] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const forgotPasswordRoute = useRouteMatch({ path: FORGOT_PASSWORD_PATH, exact: true });
    const forgotPasswordLegacyRoute = useRouteMatch({ path: FORGOT_PASSWORD_PATHH, exact: true });
    const isForgotPasswordOpen = Boolean(forgotPasswordRoute);
    const isSetPasswordOpen = Boolean(forgotPasswordLegacyRoute);

    const handleFBLogin = useLoginHandler();
    const handleGoogleLogin = useGoogleLoginHandler();
    const handleAppleLogin = useAppleLoginHandler();

    useEffect(() => {
        if (isForgotPasswordOpen || isSetPasswordOpen) {
            setLoginModalOpen(false);
        }
    }, [isForgotPasswordOpen, isSetPasswordOpen]);

    const heroCards = [
        {
            className: 'landingpage-profile-card--one',
            image: profil1,
            tag: 'Reisen',
            name: 'Anna, 24',
            location: 'Stuttgart, DE',
        },
        {
            className: 'landingpage-profile-card--two',
            image: profil2,
            tag: 'Date Night',
            name: 'Leon, 27',
            location: 'Köln, DE',
        },
        {
            className: 'landingpage-profile-card--three',
            image: profil3,
            tag: 'Herzklopfen',
            name: 'Emilia, 26',
            location: 'München, DE',
        },
        {
            className: 'landingpage-profile-card--four',
            image: profil4,
            tag: 'Kochen',
            name: 'Noah, 29',
            location: 'Frankfurt, DE',
        },
    ];

    const highlightCards = [
        {
            icon: <SearchRoundedIcon fontSize="large" />,
            title: 'Offen für alles',
            text: 'Versende Nachrichten, Bilder, Videos, Emojis und kleine Überraschungen im Chat. Teile mehr als Worte.',
        },
        {
            icon: <FavoriteRoundedIcon fontSize="large" />,
            title: 'Der perfekte Partner',
            text: 'Erhalte jeden Tag individuell auf dich abgestimmte Vorschläge und entdecke neue Lieblingsmenschen.',
        },
        {
            icon: <TravelExploreRoundedIcon fontSize="large" />,
            title: 'Lerne Singles kennen',
            text: 'Entdecke spannende Kontakte direkt in deiner Nähe und sei zur richtigen Zeit am richtigen Ort.',
        },
        {
            icon: <ShieldRoundedIcon fontSize="large" />,
            title: 'Sicheres Umfeld',
            text: 'Verifiziere Profile, chatte anonym und behalte Kontrolle über Privatsphäre und Sichtbarkeit.',
        },
    ];

    const closingCards = [
        {
            className: 'landingpage-date-card--back',
            image: profil5,
            tag: 'Romantik',
            name: 'Mia, 26',
            location: 'Düsseldorf, DE',
        },
        {
            className: 'landingpage-date-card--front',
            image: profil6,
            tag: 'Dates',
            name: 'Ben, 29',
            location: 'Frankfurt, DE',
        },
    ];

    const heroButtons =
        Config.GLOBAL_SITE_DOMAIN === 'voluu.de'
            ? [
                  {
                      icon: <AutoAwesomeRoundedIcon />,
                      label: 'Für iOS herunterladen',
                      onClick: () => window.open('https://apps.apple.com/de/app/voluu/id6478861475', '_blank', 'noopener,noreferrer'),
                  },
                  {
                      icon: <AndroidIcon />,
                      label: 'Für Android herunterladen',
                      onClick: () =>
                          window.open(
                              'https://play.google.com/store/apps/details?id=com.voluu.voluuapp',
                              '_blank',
                              'noopener,noreferrer'
                          ),
                  },
              ]
            : [
                  {
                      icon: <FavoriteRoundedIcon />,
                      label: 'Jetzt kostenlos registrieren',
                      onClick: () => history.push(REGISTER_USER),
                  },
                  {
                      icon: <ForumRoundedIcon />,
                      label: 'Schon Mitglied? Einloggen',
                      onClick: () => setLoginModalOpen(true),
                  },
              ];

    return (
        <ThemeProvider theme={createTheme(DefaultTheme, deDE)}>
            <div className="landingpage-romance">
                <AppbarComponent />

                <main className="landingpage-shell">
                    <section className="landingpage-section landingpage-section--hero">
                        <span className="landingpage-heart landingpage-heart--hero-1" aria-hidden="true">
                            ❤
                        </span>
                        <span className="landingpage-heart landingpage-heart--hero-2" aria-hidden="true">
                            💗
                        </span>
                        <span className="landingpage-heart landingpage-heart--hero-3" aria-hidden="true">
                            💕
                        </span>
                        <span className="landingpage-heart landingpage-heart--hero-4" aria-hidden="true">
                            🥰
                        </span>

                        <div className="landingpage-content landingpage-hero-layout">
                            <div className="landingpage-hero-copy">
                                <div className="landingpage-photo-cluster">
                                    {heroCards.map((card) => (
                                        <article key={card.name} className={`landingpage-profile-card ${card.className}`}>
                                            <div className="landingpage-profile-card__image-wrap">
                                                <img src={card.image} alt={card.name} className="landingpage-profile-card__image" />
                                                <span className="landingpage-profile-card__tag">{card.tag}</span>
                                            </div>

                                            <div className="landingpage-profile-card__meta">
                                                <strong>{card.name}</strong>
                                                <span className="landingpage-profile-card__location">
                                                    <LocationOnRoundedIcon />
                                                    {card.location}
                                                </span>
                                            </div>
                                        </article>
                                    ))}
                                </div>

                                <div className="landingpage-headline-block">
                                    <h1 className="landingpage-hero-title">
                                        Menschen zum <span>Verlieben</span> zusammenbringen
                                    </h1>
                                    <p className="landingpage-hero-subtitle">
                                        Wo das digitale &quot;Hallo&quot; zur großen Liebe wird.
                                    </p>

                                    <div className="landingpage-hero-actions">
                                        {heroButtons.map((button) => (
                                            <Button
                                                key={button.label}
                                                className="landingpage-store-button"
                                                startIcon={button.icon}
                                                onClick={button.onClick}
                                            >
                                                {button.label}
                                            </Button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <aside className="landingpage-cta-card">
                                <div className="landingpage-cta-card__content">
                                    <h2>Jetzt kostenlos anmelden</h2>
                                    <p>und neue Leute kennenlernen</p>

                                    <Button
                                        className="landingpage-cta-primary"
                                        onClick={() => history.push(REGISTER_USER)}
                                        disabled={isLoading}
                                    >
                                        Weiter mit E-Mail
                                    </Button>

                                    <div className="landingpage-cta-divider">ODER</div>

                                    <div className="landingpage-cta-social landingpage-cta-social--google">
                                        <GoogleLoginButton setLoading={setLoading} onLoginFinished={handleGoogleLogin} />
                                    </div>

                                    <div className="landingpage-cta-social landingpage-cta-social--facebook">
                                        <FBLoginButton
                                            setLoading={setLoading}
                                            onLoginFinished={handleFBLogin}
                                            style={{
                                                backgroundColor: 'transparent',
                                                background: 'transparent',
                                                boxShadow: 'none',
                                            }}
                                        />
                                    </div>

                                    {Config.APPLE_APP_ID ? (
                                        <div className="landingpage-cta-social landingpage-cta-social--apple">
                                            <AppleLoginButton setLoading={setLoading} onLoginFinished={handleAppleLogin} />
                                        </div>
                                    ) : (
                                        <Button className="landingpage-cta-secondary" onClick={() => setLoginModalOpen(true)}>
                                            Schon Mitglied? Hier einloggen
                                        </Button>
                                    )}
                                </div>
                            </aside>
                        </div>
                    </section>

                    <section className="landingpage-section landingpage-section--highlights">
                        <span className="landingpage-heart landingpage-heart--highlight-1" aria-hidden="true">
                            💗
                        </span>
                        <span className="landingpage-heart landingpage-heart--highlight-2" aria-hidden="true">
                            ❤
                        </span>

                        <div className="landingpage-content">
                            <div className="landingpage-highlights-heading">
                                <div className="landingpage-brand-lockup">
                                    <img src={logoWithWriting} alt={Config.GLOBAL_SITE_NAME} />
                                </div>

                                <div className="landingpage-title-block">
                                    <p className="landingpage-script-heading">Entdecke die Highlights von</p>
                                    <h2>{Config.GLOBAL_SITE_NAME}</h2>
                                </div>
                            </div>

                            <div className="landingpage-feature-grid">
                                {highlightCards.map((card) => (
                                    <article key={card.title} className="landingpage-feature-card">
                                        <div className="landingpage-feature-card__icon">{card.icon}</div>
                                        <h3>{card.title}</h3>
                                        <p>{card.text}</p>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="landingpage-section landingpage-section--closing">
                        <span className="landingpage-heart landingpage-heart--closing-1" aria-hidden="true">
                            💕
                        </span>
                        <span className="landingpage-heart landingpage-heart--closing-2" aria-hidden="true">
                            ❤
                        </span>
                        <span className="landingpage-heart landingpage-heart--closing-3" aria-hidden="true">
                            😍
                        </span>

                        <div className="landingpage-content landingpage-closing-layout">
                            <div className="landingpage-date-cards">
                                {closingCards.map((card) => (
                                    <article key={card.name} className={`landingpage-date-card ${card.className}`}>
                                        <div className="landingpage-date-card__image-wrap">
                                            <img src={card.image} alt={card.name} className="landingpage-date-card__image" />
                                            <span className="landingpage-date-card__tag">{card.tag}</span>
                                        </div>

                                        <div className="landingpage-date-card__meta">
                                            <strong>{card.name}</strong>
                                            <span className="landingpage-date-card__location">
                                                <LocationOnRoundedIcon />
                                                {card.location}
                                            </span>
                                        </div>
                                    </article>
                                ))}
                            </div>

                            <div className="landingpage-closing-copy">
                                <h2>
                                    Erlebe aufregende Flirts und spannende <span>Dates</span> mit
                                </h2>
                                <img src={logoWithWriting} alt={Config.GLOBAL_SITE_NAME} className="landingpage-closing-logo" />
                                <Button className="landingpage-cta-primary" onClick={() => history.push(REGISTER_USER)}>
                                    Jetzt kostenlos registrieren
                                </Button>
                            </div>
                        </div>
                    </section>
                </main>

                <footer className="landingpage-footer">
                    <nav className="landingpage-footer__links">
                        <Link to="/support" className="link">
                            Kontakt
                        </Link>
                        <Link to="/impressum" className="link">
                            Impressum
                        </Link>
                        <Link to="/datenschutz" className="link">
                            Datenschutz
                        </Link>
                        <Link to="/agb" className="link">
                            AGB
                        </Link>
                        <Link to="/content-guidelines" className="link">
                            Content &amp; Community Guidelines
                        </Link>
                    </nav>
                    <p className="landingpage-footer__legal">
                        Diese Webseite darf ausschlie&szlig;lich von Personen genutzt werden, die mindestens 18 Jahre alt sind. Die Plattform stellt
                        einen virtuellen Chat-Dienst f&uuml;r unterhaltsame, flirtende und fantasievolle Gespr&auml;che zur Verf&uuml;gung. Hierbei
                        werden fiktive Profile verwendet, mit denen keine pers&ouml;nlichen oder realen Treffen m&ouml;glich sind. Die Kosten je
                        Nachricht k&ouml;nnen je nach gew&auml;hlter Zahlungsart unterschiedlich ausfallen. Bitte informieren Sie sich vor der Nutzung
                        der Webseite &uuml;ber die geltenden Nutzungsbedingungen und Datenschutzbestimmungen.
                    </p>
                </footer>

                <LoginModal open={loginModalOpen && !isForgotPasswordOpen && !isSetPasswordOpen} onClose={() => setLoginModalOpen(false)} />
                <ForgotPasswordModal open={isForgotPasswordOpen} />
                {isSetPasswordOpen && <ForgotPasswordModalx />}
            </div>
        </ThemeProvider>
    );
});
